// extracted by mini-css-extract-plugin
export default {"addOn":"AddOnItem_addOn__30iv4","price":"AddOnItem_price__w-bZe","itemSpacing":"AddOnItem_itemSpacing__tUzps","checkBoxGroup":"AddOnItem_checkBoxGroup__DzOTI"};